import React, { useCallback, useMemo } from 'react'
import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'
import { DEFAULT_TYPE, createSelectNotification, removeNotification } from '../../store/notifications'
import { Toast } from '@maui/elements'

function Notification({ id }) {
  const dispatch = useDispatch()
  const selectNotification = useMemo(() => createSelectNotification(id), [id])

  const notification = useSelector(selectNotification)
  const onClose = useCallback(() => {
    dispatch(removeNotification(id))
  }, [dispatch, id])

  const {
    message,
    source,
    type = DEFAULT_TYPE,
  } = notification

  return (
    <Toast
      onClose={onClose}
      title={source}
      variant={type}
      message={message}
    />
  )
}

Notification.propTypes = {
  id: PropTypes.string,
}

export default Notification
